// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__KIQec","videoContainer":"VideoPlayer_videoContainer__xm7ct","loadingOverlay":"VideoPlayer_loadingOverlay__pIj3a"};